import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type FloatingCTAProps = {
  anchorId: string;
};
export function FloatingCTA({
  anchorId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-34" data-mp="38c0ifgozqie6">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-4 pb-4 pt-2 sm:pb-6" initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-35" data-mp="38cs5220m15sb">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-coral px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-[0_14px_30px_-8px_rgba(168,64,31,0.7)] ring-2 ring-white hover:bg-coral-dark sm:text-lg" data-id="element-36" data-mp="335nj7si1xl5p">
            <span data-id="element-37" data-mp="2kdumpo3rxht8">Get it now for just $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="2kap0cgmj4u17" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}